import { Grid, TextField, Typography } from "@mui/material";

import DatePicker from "components/DatePicker";
import React from "react";
import Select from "components/Select";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import CoinSelectItem from "components/CoinSelectItem";

function RequestHistoryFilters() {
  const [searchParams, setSearchParams] = useSearchParams();

  const requestHistoryForm = useSelector(
    (state) => state.wallet.requestHistoryForm?.data
  );

  const defaultValues = {
    coinId: +searchParams.get("coinId") || -1,
    basketId: +searchParams.get("basketId") || -1,
    startDate: searchParams.get("startDate") || "",
    endDate: searchParams.get("endDate") || "",
    sideId: +searchParams.get("sideId") || 0,
    stateId: +searchParams.get("stateId") || 0,
    typeId: +searchParams.get("typeId") || 0,
    forId: +searchParams.get("forId") || 0,
    userName: searchParams.get("userName") || "",
  };

  const { watch, setValue } = useForm({ defaultValues });

  const handleChange = (value, fieldName) => {
    setValue(fieldName, value);

    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      page: 1,
      [fieldName]: value,
    });
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          Coin
        </Typography>

        <Select
          items={requestHistoryForm?.lisCoin}
          itemText="name"
          itemValue="id"
          value={watch("coinId")}
          dir="ltr"
          onChange={(e) => handleChange(e.target.value, "coinId")}
          customValue={(data) => <CoinSelectItem data={data} />}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          Basket
        </Typography>

        <Select
          items={requestHistoryForm?.lisBasket}
          itemText="name"
          itemValue="id"
          value={watch("basketId")}
          onChange={(e) => handleChange(e.target.value, "basketId")}
          dir="ltr"
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          Side
        </Typography>

        <Select
          items={requestHistoryForm?.lisSide}
          itemText="name"
          dir="ltr"
          itemValue="id"
          value={watch("sideId")}
          onChange={(e) => handleChange(e.target.value, "sideId")}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          State
        </Typography>

        <Select
          items={requestHistoryForm?.lisState}
          itemText="name"
          itemValue="id"
          value={watch("stateId")}
          onChange={(e) => handleChange(e.target.value, "stateId")}
          dir="ltr"
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          Type
        </Typography>

        <Select
          items={requestHistoryForm?.lisType}
          itemText="name"
          itemValue="id"
          value={watch("typeId")}
          onChange={(e) => handleChange(e.target.value, "typeId")}
          dir="ltr"
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          For
        </Typography>

        <Select
          items={requestHistoryForm?.lisFor}
          itemText="name"
          itemValue="id"
          value={watch("forId")}
          onChange={(e) => handleChange(e.target.value, "forId")}
          dir="ltr"
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          Start Date
        </Typography>

        <DatePicker
          value={watch("startDate")}
          onChange={(e) => handleChange(e, "startDate")}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          End Date
        </Typography>

        <DatePicker
          value={watch("endDate")}
          onChange={(e) => handleChange(e, "endDate")}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          User Name
        </Typography>

        <TextField
          value={watch("userName")}
          onChange={(e) => handleChange(e.target.value, "userName")}
        />
      </Grid>
    </Grid>
  );
}

export default RequestHistoryFilters;
